import diacritics from 'diacritics';

import { isNotNullOrUndefined } from './null-safety.js';
import { isNullOrUndefinedOrEmpty } from './string.js';
import { AlphabetUtils } from './alphabet-utils.js';

export abstract class SearchUtils {
  static generateSearchQueryArray(queryParams: Array<string | null | undefined>, atomicQueryParams?: Array<string | null | undefined> | null | undefined) : Array<string> {
    const result = new Set<string>();

    for(const queryParam of queryParams) {
      if(isNullOrUndefinedOrEmpty(queryParam)) {
        continue;
      }

      const sanitizedQueryParam = this.sanitizeStringForSearch(queryParam);
      if(isNullOrUndefinedOrEmpty(sanitizedQueryParam)) {
        continue;
      }

      if(sanitizedQueryParam.length <= 4) {
        result.add(sanitizedQueryParam);
        continue;
      }

      for(let start = 0; start < sanitizedQueryParam.length; ++start) {
        const end = start + 4;
        if(end > sanitizedQueryParam.length) {
          break;
        }

        result.add(sanitizedQueryParam.substring(start, end));
      }
    }

    if(isNotNullOrUndefined(atomicQueryParams) && atomicQueryParams.length > 0) {
      for(const queryParam of atomicQueryParams) {
        if(isNullOrUndefinedOrEmpty(queryParam)) {
          continue;
        }

        const sanitizedQueryParam = this.sanitizeStringForSearch(queryParam);
        if(isNullOrUndefinedOrEmpty(sanitizedQueryParam)) {
          continue;
        }

        result.add(sanitizedQueryParam);
        continue;
      }
    }

    return [...result];
  }

  static sanitizeStringForSearch(str: string | null | undefined): string | null | undefined {
    if(isNullOrUndefinedOrEmpty(str)) {
      return str;
    }

    const preSanitized = diacritics.remove(str);
    const resultChars = new Array<string>();

    for(const c of preSanitized) {
      if(AlphabetUtils.FULL_ALPHA_NUMERIC.includes(c)) {
        resultChars.push(c);
      }
    }

    return resultChars.join('').toLowerCase();
  }
}
